import React, {useEffect, useRef, useState} from 'react';
import NavbarReturn from '../components/NavbarReturn';
import FooterAdmin from '../components/FooterAdmin';
import AlertBox from '../components/AlertBox';
import {ArrowUpTrayIcon, ChevronDownIcon, MagnifyingGlassIcon, XMarkIcon} from '@heroicons/react/24/outline';
import { ref, uploadBytes, getDownloadURL } from 'firebase/storage';
import { collection, getDocs, setDoc, doc, updateDoc, deleteDoc} from "firebase/firestore";
import {database, storage} from '../config/firebaseConfig';
import { Toaster } from 'react-hot-toast';
import AlertOnLoading from '../components/AlertOnLoading';
import { LazyLoadImage } from "react-lazy-load-image-component";

function TestsAdmin() {
    const WAIT_TIME = 1000; //Waits for 0.5s
    const notInitialRender = useRef(false);

    const SUCCESS = "success"
    const WARNING = "warning"
    const DANGER = "danger"

    const [newData, setNewData] = useState(true); //it functions to validate if it needs to re-render
    const [uploading, setUploading] = useState(false);
    const [updating, setUpdating] = useState(false);

    const [imageUpload, setImageUpload] = useState(null);
    const [imageURL, setImageURL] = useState('');

    const [testIdSelected, setTestIdSelected]= useState('');
    
    const [currentPage, setCurrentPage] = useState(1);
    const testsPerPages = 5;

    const [categories, setCategories] = useState(null);
    const [searchCategory, setSearchCategory] = useState("");
    
    const [openDropDown, setOpenDropDown] = useState(false);
    const [openDropDownPopUp, setOpenDropDownPopUp] = useState(false);
    
    const [tests, setTests] = useState(null);

    const [selected, setSelected] = useState("");
    const [testName, setTestName] = useState("");
    const [testPrice, setTestPrice] = useState("");
    const [imageSelected, setImageSelected] = useState("Imagen");
    const [testDescription, setTestDescription] = useState("");

    const lastTestIndex = currentPage * testsPerPages;
    const firstTestIndex = lastTestIndex - testsPerPages;

    const togglePopupDelete = (testId) =>{
        [].forEach.bind(document.getElementsByClassName(`popup_delete ${testId}`),function(itm){
          itm.style.display = "flex";
        })();
    }
  
    const closePopupDelete = (testId) =>{
        [].forEach.bind(document.getElementsByClassName(`popup_delete ${testId}`),function(itm){
            itm.style.display = "none";
        })();
    }

    /*
        It hides the PopUp of the test
    */
    const closePopUpTest = (testId) => {
        const popup = document.getElementById(testId);
        setTestName('');
        setTestPrice('');
        setSelected('');
        setImageURL('');
        setTestDescription('');
        setTestIdSelected('');
        setImageSelected('Imagen');
        popup.classList.add('hidden');
        popup.classList.remove('flex');
    }

    /*
        It shows the PopUp of the test
    */
    const togglePopUpTest = (testId, name, price, category, image, description) => {
        const popup = document.getElementById(testId);
        popup.classList.remove('hidden');
        popup.classList.add('flex');
        setTestName(name);
        setTestPrice(price);
        setSelected(category);
        setImageURL(image);
        setTestDescription(description);
        setTestIdSelected(testId);
        setImageSelected("Imagen");
    }

    /*
        It updates the text of the image's input for PopUp
    */
    function updateTextPopUp(event) {
        setImageUpload(event.target.files[0]);
        const newText = event.target.files[0];
        const getFileName = newText.name;
        setImageSelected(getFileName);
    }

    /*
        It updates the text of the image's input
    */
    function updateText(event) {
        setImageUpload(event.target.files[0]);
        const newText = document.getElementById("uploadImage").value;
        const getFileName = newText.split("\\");
        setImageSelected(getFileName[getFileName.length - 1]);
    }

    /*
        Creates a new Test 
    */
    async function createTest() {
        const testCollectionRef = collection(database, "pruebas");

        if (testName === "") {
            AlertBox(WARNING, '¡Debe ingresar el nombre de la prueba!')
            return;

        } else if (testPrice === "") {
            AlertBox(WARNING, '¡Debe ingresar un precio para la prueba!');
            return;

        }else if (selected === "") {
            AlertBox(WARNING, '¡Debe seleccionar una categoría para la prueba!');
            return;

        } else if (testDescription === "") {
            AlertBox(WARNING, '¡Debe ingresar una descripción para la prueba!');
            return;

        }  else {
            const addButton = document.querySelectorAll("#addRegister");
            addButton[0].setAttribute("disabled", true);
            addButton[1].setAttribute("disabled", true);

            setUploading(true);

            if (imageUpload == null) {
                const newTestRef = doc(testCollectionRef);
                setDoc(newTestRef, {nombre:testName, precio:testPrice, categoria:selected, imagen: process.env.REACT_APP_DEFAULT_IMAGE_URL, descripcion: testDescription});

                setImageSelected("Imagen");
                setTestName("");
                setTestPrice("");
                setSelected("");
                setTestDescription("");
                setNewData(true);

                addButton[0].removeAttribute("disabled");
                addButton[1].removeAttribute("disabled");

                setUploading(false);
                AlertBox(SUCCESS, '¡Prueba creada correctamente!');
                return;
            } else {
                const imageRef = ref(storage, `images/${imageUpload?.name}`);

                uploadBytes(imageRef, imageUpload).then(async () => {

                    const imageURL = await getDownloadURL(imageRef);
                    const newTestRef = doc(testCollectionRef);
                    setDoc(newTestRef, {nombre:testName, precio:testPrice, categoria:selected, imagen: imageURL, descripcion: testDescription});
    
                    setImageSelected("Imagen");
                    setTestName("");
                    setTestPrice("");
                    setSelected("");
                    setTestDescription("");
                    setNewData(true);
    
                    addButton[0].removeAttribute("disabled");
                    addButton[1].removeAttribute("disabled");
    
                    setUploading(false);
                    AlertBox(SUCCESS, '¡Prueba creada correctamente!');
                    return;
                })
                .catch(error => {
                    console.log("Error al subir la imagen: " + error);
    
                    addButton[0].removeAttribute("disabled");
                    addButton[1].removeAttribute("disabled");
    
                    setUploading(false);
    
                    AlertBox(DANGER, '¡Ha ocurrido un error inesperado!');
                    return;
                });
            }
            
        }
    }

    const deleteNumbers = (selectedId) => {
        return selectedId.replace(/\d+/g, '');
    }

    /*
        Updates a Test 
    */
    async function updateTest() {
        if (imageSelected !== "Imagen") {
            const updateButton = document.querySelectorAll(`button.${deleteNumbers(testIdSelected)}`);
            updateButton[0].setAttribute("disabled", true);

            setUpdating(true);
            const imageRef = await ref(storage, `images/${imageUpload.name}`);
            uploadBytes(imageRef, imageUpload).then(async () => {
                const imageURL = await getDownloadURL(imageRef);
                const updateTestRef = doc(database, 'pruebas', testIdSelected);
                await updateDoc(updateTestRef, {nombre:testName, precio:testPrice, categoria:selected, imagen: imageURL, descripcion: testDescription});

                setImageSelected("Imagen");
                setTestName("");
                setTestPrice("");
                setSelected("");
                setTestDescription("");
                setNewData(true);

                updateButton[0].removeAttribute("disabled");

                setUpdating(false);
                AlertBox(SUCCESS, '¡Prueba actualizada correctamente!');
                closePopUpTest(testIdSelected);
                return;
            })
            .catch(error => {
                console.log("Error al subir la imagen ", error);
                updateButton[0].removeAttribute("disabled");

                setUpdating(false);
                AlertBox(DANGER, '¡Ha ocurrido un error inesperado!');
                return;
            });
        } else {
            const updateButton = document.querySelectorAll(`button.${deleteNumbers(testIdSelected)}`);
            updateButton[0].setAttribute("disabled", true);
            
            setUpdating(true);
            const updateTestRef = doc(database, 'pruebas', testIdSelected);
            await updateDoc(updateTestRef, {nombre:testName, precio:testPrice, categoria:selected, imagen: imageURL, descripcion: testDescription});

            setImageSelected("Imagen");
            setTestName("");
            setTestPrice("");
            setSelected("");
            setTestDescription("");
            setNewData(true);

            updateButton[0].removeAttribute("disabled");

            setUpdating(false);
            AlertBox(SUCCESS, '¡Prueba actualizada correctamente!');
            closePopUpTest(testIdSelected);
            return;
        }
        
    }

    /*
        Deletes a Test 
    */
    async function deleteTest(testId) {
        const testDoc = doc(database, "pruebas", testId);
        await deleteDoc(testDoc);
        setNewData(true);
        AlertBox(SUCCESS, '¡Prueba eliminada correctamente!');
        closePopupDelete(testId)
    }

    /*
        Loads the DropDown of categories 
    */
    useEffect(() => {
        const interval = setInterval(() => { //Autorize re-render
            if (newData) {
                const categoryCollectionRef = collection(database, "categorias");
                
                const getCategories = async() => {
                    const data = await getDocs(categoryCollectionRef);
                    setCategories(data.docs.map((doc) => ({...doc.data(), id: doc.id})));
                }
                
                getCategories();
                }
            }, WAIT_TIME);
            return () => clearInterval(interval);
    }, [categories, newData])

    /*
        Gets all tests 
    */
    useEffect(() => {
            if (notInitialRender.current && newData){
                AlertOnLoading(WAIT_TIME+100);
            }else {
                notInitialRender.current = true;
            } 
            if (newData) {
                const testsRef = collection(database, "pruebas");
                const getTests = async() => {
                    const data = await getDocs(testsRef);
                    setTests(data.docs.map((doc) => ({...doc.data(), id: doc.id})));
                }
                
                const interval = setInterval(() => { //Autorize re-render
                    getTests();
                    setNewData(!newData);
                }, WAIT_TIME);
                return () => clearInterval(interval);
            }
    }, [tests, newData])

    return (
        <div>
            <div>
            <Toaster
            toastOptions={{
            duration:3000,
        }}/>

            </div>
            
            <NavbarReturn />
            <div className='w-full h-navbar-mobile sm:h-navbar'></div>
            
            <div className='px-4 py-6 flex flex-col w-full h-auto bg-white lg:py-8 sm:px-8 min-h-screen'>
                <h2 className='lg:text-xl'>Agregar una Prueba </h2>
                <span className='lg:w-80 w-48 border border-primary-100'></span>

                <div className="h-auto px-4 pt-6 w-60 sm:flex sm:flex-row sm:w-full sm:justify-start">
                    
                    <div className='sm:w-64 md:w-72 lg:w-input-web'>
                        <input type={"text"} placeholder="Nombre" onChange={(ev) => {setTestName(ev.target.value)}} value={testName}
                        className='md:text-base text-sm w-full h-input-height py-2 px-3 text-input-font bg-primary-300
                        focus:outline-none focus:border focus:border-primary-100 focus:shadow-md'/>

                        <input type={"text"} placeholder="Precio" onChange={(ev) => {setTestPrice(ev.target.value)}} value={testPrice}
                        className='md:text-base text-sm w-full h-input-height py-2 px-3 text-input-font bg-primary-300
                        focus:outline-none focus:border focus:border-primary-100 focus:shadow-md mt-4'/>

                        <div className='relative w-full h-input-height py-2 px-3 overflow-hidden
                            text-input-font bg-primary-300 focus:outline-none 
                            focus:border focus:border-primary-100 focus:shadow-md mt-4'>
                            <div className='w-40 sm:w-52 md:w-60 lg:w-96 overflow-hidden'>
                                <label htmlFor="file" id="fileName" className={`${imageSelected==="Imagen"? "text-placeholder":"text-input-font"} text-sm md:text-base`}>{imageSelected}</label>
                            </div>
                            <div className='absolute inset-y-0 right-0 flex items-center'>
                                <ArrowUpTrayIcon className={`${imageSelected==="Imagen"? "text-placeholder":"text-input-font"} h-4 w-4 md:h-5 md:w-5 mx-2 hover:cursor-pointer`} />
                            </div>
                            <input onChange={updateText} id="uploadImage" className='w-full absolute file:w-full opacity-0 cursor-pointer left-0 -top-0 h-input-height' 
                            aria-hidden='true' type={"file"} accept=".jpeg, .jpg, .png, .webp, .svg" />
                        </div>

                        <div className='hidden sm:block w-full'>
                            <button onClick={createTest} id="addRegister"
                                className='mt-4 mb-6 w-full h-8 text-sm sm:text-base sm:h-9 bg-primary-100 text-white rounded font-bold form1:text-xl hover:bg-primary-200 disabled:bg-primary-200'>
                                {!uploading? 
                                "Agregar"
                                : 
                                <div className="w-full flex justify-center items-center"> 
                                    <svg fill='none' className="w-8 h-8 animate-spin" viewBox="0 0 32 32" xmlns='http://www.w3.org/2000/svg'>
                                    <path clipRule='evenodd'
                                        d='M15.165 8.53a.5.5 0 01-.404.58A7 7 0 1023 16a.5.5 0 011 0 8 8 0 11-9.416-7.874.5.5 0 01.58.404z'
                                        fill='currentColor' fillRule='evenodd' />
                                    </svg> 
                                    Agregando
                                </div>}
                            </button>
                        </div>
                    </div>

                    <div className='sm:w-64 md:w-72 sm:ml-4 lg:w-input-web'>
                        <div className='sm:mt-0 cursor-pointer w-full h-input-height py-1 pl-3 text-navFont-100 bg-primary-300 focus:outline-none 
                            focus:border focus:border-primary-100 focus:shadow-md
                            flex flex-row items-center justify-between mt-4'
                            onClick={() => setOpenDropDown(!openDropDown)}>
                                {
                                    selected ? <p className='text-input-font md:text-base text-sm overflow-hidden'>{selected}</p> 
                                    : <p className='text-placeholder md:text-base text-sm overflow-hidden'>Categoría</p>
                                }
                                
                                <ChevronDownIcon className={`md:h-5 md:w-5 h-4 w-4 mx-2 hover:cursor-pointer ${selected? "text-input-font":"text-placeholder"}
                                ${openDropDown && "rotate-180"}`} />
                        </div>

                        <ul className={`${selected? "text-input-font":"text-placeholder"} bg-primary-300 mt-1 overflow-y-auto 
                            ${openDropDown ? "max-h-[104px]" : "max-h-0"}
                        `}>
                            <div className='flex items-center px-2 border-b border-primary-100'>
                                <MagnifyingGlassIcon className={`md:h-5 md:w-5 h-4 w-4 ${searchCategory? "text-input-font":"text-placeholder"}`} />
                                <input type="text" placeholder="Buscar Categoría"
                                value={searchCategory}
                                className='text-input-font md:text-base text-sm w-full h-8 
                                bg-primary-300 p-2 outline-none border-none' onChange={(e)=>setSearchCategory(e.target.value.toLowerCase())}/>
                            </div>
                            {categories?.map((category) => {
                                return(
                                    <div key={category.id} >
                                        <li
                                        className={`cursor-pointer p-2 md:text-base text-sm text-input-font hover:text-primary-100 ease-in-out
                                        ${category?.nombre?.toLowerCase() === selected?.toLocaleLowerCase()
                                            && 'bg-primary-200 text-white'
                                        }
                                        ${category?.nombre?.toLowerCase().startsWith(searchCategory) 
                                        ? "block" : "hidden"}`}
                                        onClick={()=>{
                                            if (category?.nombre?.toLowerCase() !== selected.toLocaleLowerCase()) {
                                                setSelected(category?.nombre);
                                                setOpenDropDown(false);
                                                setSearchCategory("");
                                            }
                                        }}>{category.nombre}</li>
                                    </div>
                                );
                            })}
                        </ul>

                        <div>
                            <textarea className={`${openDropDown? "hidden": "block"} md:text-base mt-3 py-2 px-3 h-text-area-height w-full text-sm text-input-font bg-primary-300
                            focus:outline-none focus:border focus:border-primary-100 focus:shadow-md resize-none`}
                            onChange={(ev) => {setTestDescription(ev.target.value)}} value={testDescription}
                            id="description" name="description" rows="7" cols="41" placeholder='Descripción'></textarea>
                        </div>
                    </div>
                </div>
                
                <div className='w-52 sm:hidden'>
                    <button onClick={createTest} id="addRegister"
                        className='mt-4 mb-6 ml-4 w-full h-8 text-sm sm:text-base sm:h-9 bg-primary-100 text-white rounded font-bold form1:text-xl hover:bg-primary-200 disabled:bg-primary-200'>
                        {!uploading? 
                        "Agregar"
                        : 
                        <div className="w-full flex justify-center items-center"> 
                            <svg fill='none' className="w-6 h-6 animate-spin" viewBox="0 0 32 32" xmlns='http://www.w3.org/2000/svg'>
                            <path clipRule='evenodd'
                                d='M15.165 8.53a.5.5 0 01-.404.58A7 7 0 1023 16a.5.5 0 011 0 8 8 0 11-9.416-7.874.5.5 0 01.58.404z'
                                fill='currentColor' fillRule='evenodd' />
                            </svg> 
                            Agregando
                        </div>}
                    </button>
                </div>
                
                
                <h2 className='lg:text-xl mt-10'>Todas las Pruebas</h2>
                <span className='lg:w-80 w-48 border border-primary-100'></span>
                
                <div className='w-full flex flex-row justify-center'>
                    <div className='w-full flex flex-col justify-center items-center'>
                        {tests? tests.slice(firstTestIndex, lastTestIndex).map((test)=> (
                            <div className='w-full flex justify-center' key={test.id}>
                                <div className='max-w-table-web w-4/5 p-2 gap-2 grid grid-rows-9 mt-6 border border-primary-100 md:flex md:flex-col'>
                                    <div className='hidden md:grid grid-cols-2 gap-2'>
                                        
                                        <div className='flex flex-col space-y-2'>
                                            <div className='bg-primary-300 w-full h-9 flex justify-center items-center'>
                                                <h3 className='text-primary-100 text-sm lg:text-lg'>Nombre y Descripción</h3>
                                            </div>

                                            <div className='bg-background w-full h-9 flex justify-center items-center'>
                                                <p className='text-navFont-100 text-base lg:text-xl font-bold'>{test.nombre}</p>
                                            </div>
                                            <div className='bg-background w-full h-24 overflow-y-auto flex justify-center'>
                                                <p className='text-navFont-100 text-sm lg:text-lg text-center px-1'>{test.descripcion}</p>
                                            </div>

                                            <div className='w-full h-9 flex justify-center items-center'>
                                                <div className='mr-1 bg-primary-300 w-1/2 h-9 flex justify-center items-center'>
                                                    <h3 className='text-primary-100 text-sm lg:text-lg'>Categoría</h3>
                                                </div>
                                                <div className='ml-1 bg-primary-300 w-1/2 h-9 flex justify-center items-center'>
                                                    <h3 className='text-primary-100 text-sm lg:text-lg'>Precio</h3>
                                                </div>
                                            </div>

                                            <div className='w-full h-9 flex justify-center items-center'>
                                                <div className='mr-1 bg-background w-1/2 h-9 flex justify-center items-center'>
                                                    <p className='text-navFont-100 text-sm lg:text-lg'>{test.categoria}</p>
                                                </div>
                                                <div className='ml-1 bg-background w-1/2 h-9 flex justify-center items-center'>
                                                    <p className='text-navFont-100 text-sm lg:text-lg'>₡ {test.precio}</p>
                                                </div>
                                            </div>

                                            <div className='bg-primary-300 w-full h-9 flex justify-center items-center'>
                                                <h3 className='text-primary-100 text-sm lg:text-lg'>Acción</h3>
                                            </div>

                                            <div className='w-full h-9 flex justify-center items-center bg-background'>
                                                <div className='mr-1 bg-background w-1/2 h-9 flex justify-center items-center'>
                                                    <button onClick={() => {togglePopUpTest(test.id, test.nombre, test.precio, test.categoria, test.imagen, test.descripcion)}} 
                                                    className='w-full h-7 text-sm sm:text-base sm:h-9 bg-primary-100 text-white rounded-md font-bold hover:bg-primary-200'>Editar Prueba</button>
                                                </div>
                                                <div className='ml-1 bg-background w-1/2 h-9 flex justify-center items-center'>
                                                    <button onClick={() => {togglePopupDelete(test.id)}} 
                                                    className='w-full h-7 text-sm sm:text-base sm:h-9 bg-danger text-white rounded-md font-bold hover:bg-red-400'>Eliminar Prueba</button>
                                                </div>
                                            </div>
                                        </div>

                                        <div className='flex flex-col space-y-2'>
                                            <div className='bg-primary-300 w-full h-9 flex justify-center items-center'>
                                                <h3 className='text-primary-100 text-sm lg:text-lg'>Imagen</h3>
                                            </div>

                                            <div className='bg-slate-600 w-full h-full flex justify-center items-center max-h-[315px]'>
                                                <LazyLoadImage src={test.imagen} className='w-full h-full max-h-80 object-cover lg:object-fit'
                                                alt=''></LazyLoadImage>
                                            </div>
                                        </div>
                                    </div>
                                    
                                    <div className='md:hidden bg-primary-300 w-full h-9 flex justify-center items-center'>
                                        <h3 className='text-primary-100 text-sm'>Nombre y Descripción</h3>
                                    </div>

                                    <div className='md:hidden bg-background w-full h-9 flex justify-center items-center'>
                                        <h3 className='text-navFont-100 text-base font-bold'>{test.nombre}</h3>
                                    </div>
                                    <div className='md:hidden bg-background w-full h-24 overflow-y-auto flex justify-center'>
                                        <p className='w-full text-center text-sm h-auto text-navFont-100 px-1'>
                                            {test.descripcion}
                                        </p>
                                    </div>

                                    <div className='md:hidden w-full h-9 flex justify-center items-center'>
                                        <div className='mr-1 bg-primary-300 w-1/2 h-9 flex justify-center items-center'>
                                            <h3 className='text-primary-100 text-sm'>Categoría</h3>
                                        </div>
                                        <div className='ml-1 bg-primary-300 w-1/2 h-9 flex justify-center items-center'>
                                            <h3 className='text-primary-100 text-sm'>Precio</h3>
                                        </div>
                                    </div>

                                    <div className='md:hidden w-full h-9 flex justify-center items-center'>
                                        <div className='mr-1 bg-background w-1/2 h-9 flex justify-center items-center'>
                                            <p className='text-navFont-100 text-sm'>{test.categoria}</p>
                                        </div>
                                        <div className='ml-1 bg-background w-1/2 h-9 flex justify-center items-center'>
                                            <p className='text-navFont-100 text-sm'>₡ {test.precio}</p>
                                        </div>
                                    </div>
                                    
                                    <div className='md:hidden bg-primary-300 w-full h-9 flex justify-center items-center'>
                                        <h3 className='text-primary-100 text-sm'>Imagen</h3>
                                    </div>

                                    <div className='md:hidden bg-slate-600 w-full h-auto flex justify-center items-center'>
                                        <LazyLoadImage src={test.imagen} className='w-full h-auto max-h-60 object-cover'
                                        alt=''></LazyLoadImage>
                                    </div>

                                    <div className='md:hidden bg-primary-300 w-full h-9 flex justify-center items-center'>
                                        <h3 className='text-primary-100 text-sm'>Acción</h3>
                                    </div>

                                    <div className='md:hidden w-full h-9 flex justify-center items-center bg-background'>
                                        <div className='mr-1 bg-background w-1/2 h-9 flex justify-center items-center'>
                                            <button onClick={() => {togglePopUpTest(test.id, test.nombre, test.precio, test.categoria, test.imagen, test.descripcion)}} 
                                            className='w-full h-7 text-sm sm:text-base sm:h-9 bg-primary-100 text-white rounded-md font-bold hover:bg-primary-200'>Editar Prueba</button>
                                        </div>
                                        <div className='ml-1 bg-background w-1/2 h-9 flex justify-center items-center'>
                                            <button onClick={() => {togglePopupDelete(test.id)}} 
                                            className='w-full h-7 text-sm sm:text-base sm:h-9 bg-danger text-white rounded-md font-bold hover:bg-red-400'>Eliminar Prueba</button>
                                        </div>
                                    </div>
                                </div>

                                <div className={`hidden fixed backdrop-blur-sm mt-navbar-mobile bg-popup inset-0 z-30 items-center justify-center`} id={test.id}> 
                                    <div className='relative sm:max-w-3xl w-full flex flex-col justify-center py-3 items-center mx-10 sm:mx-5 sm:px-3 h-auto bg-white rounded overflow-y-auto'>
                                        <div className='w-full flex flex-col items-center justify-center mt-3'>
                                            <h2 className='flex flex-row md:text-xl'>Editar una Prueba </h2>
                                            <span className='md:w-80 w-48 h-px border border-primary-100'></span>
                                        </div>
                                        <button onClick={() => {closePopUpTest(test.id)}} className='absolute top-1 right-1 hover:text-primary-100'><XMarkIcon className='w-7 h-7'/></button>
                                        <div className='sm:static sm:space-x-3 sm:items-start sm:flex-row relative w-full flex flex-col justify-center py-3 items-center mx-0 h-auto bg-white rounded overflow-y-auto'>
                                            <div className='w-full flex flex-col items-center justify-center'>
                                                

                                                <div className='w-52 mt-3 sm:w-5/6'>
                                                    <input type={"text"} placeholder="Nombre" onChange={(ev) => {setTestName(ev.target.value)}} value={testName}
                                                    className='md:text-base text-sm w-full h-input-height py-2 px-3 text-input-font bg-primary-300
                                                    focus:outline-none focus:border focus:border-primary-100 focus:shadow-md'/>
                                                </div>

                                                <div className='w-52 mt-3 sm:w-5/6'>
                                                    <input type={"text"} placeholder="Precio" onChange={(ev) => {setTestPrice(ev.target.value)}} value={testPrice}
                                                    className='md:text-base text-sm w-full h-input-height py-2 px-3 text-input-font bg-primary-300
                                                    focus:outline-none focus:border focus:border-primary-100 focus:shadow-md'/>
                                                </div>

                                                <div className='relative w-52 h-input-height py-1 px-3 overflow-hidden sm:w-5/6
                                                    text-navFont-100 bg-primary-300 focus:outline-none 
                                                    focus:border focus:border-primary-100 focus:shadow-md mt-3'>
                                                    <div className='w-40 sm:w-48 md:w-60 lg:w-64 overflow-hidden'>
                                                        <label htmlFor="file" id="fileName" className={`${imageSelected==="Imagen"? "text-placeholder":"text-input-font"} text-sm md:text-base`}>{imageSelected}</label>
                                                    </div>
                                                    <div className='absolute inset-y-0 right-0 flex items-center'>
                                                        <ArrowUpTrayIcon className={`${imageSelected==="Imagen"? "text-placeholder":"text-input-font"} h-4 w-4 md:h-5 md:w-5 mx-2 hover:cursor-pointer`} />
                                                    </div>
                                                    <input onChange={updateTextPopUp} id="uploadImage" className='w-full absolute file:w-full opacity-0 cursor-pointer left-0 -top-0 h-input-height' 
                                                    aria-hidden='true' type={"file"} accept=".jpeg, .jpg, .png, .webp, .svg" />
                                                </div>

                                                <div className='w-52 mt-1 flex flex-col bg-primary-300 py-2 px-3 sm:w-5/6'>
                                                    <h4 className='sm:text-base text-sm text-input-font'>Imagen anterior:</h4>
                                                    <LazyLoadImage className='w-full h-full max-h-60 object-cover lg:object-fit' src={imageURL} alt="">
                                                    </LazyLoadImage>
                                                </div>

                                                <div className='sm:hidden w-52 mt-3'>
                                                    <div className='sm:mt-0 cursor-pointer w-full h-input-height py-1 pl-3 text-input-font bg-primary-300 focus:outline-none 
                                                        focus:border focus:border-primary-100 focus:shadow-md
                                                        flex flex-row items-center justify-between border-none'
                                                        onClick={() => setOpenDropDownPopUp(!openDropDownPopUp)}>
                                                            {
                                                                selected ? <p className='text-input-font md:text-base text-sm overflow-hidden'>{selected}</p> 
                                                                : <p className='text-input-font md:text-base text-sm overflow-hidden'>Categoría</p>
                                                            }
                                                            
                                                            <ChevronDownIcon className={`text-input-font md:h-5 md:w-5 h-4 w-4 mx-2 hover:cursor-pointer 
                                                            ${openDropDownPopUp && "rotate-180"}`} />
                                                    </div>

                                                    <ul className={`text-input-font bg-primary-300 mt-1 overflow-y-auto 
                                                        ${openDropDownPopUp ? "max-h-24" : "max-h-0"}
                                                    `}>
                                                        <div className='flex items-center px-2 border-b border-primary-100'>
                                                            <MagnifyingGlassIcon className='md:h-5 md:w-5 h-4 w-4 text-placeholder' />
                                                            <input type="text" placeholder="Buscar Categoría"
                                                            value={searchCategory}
                                                            className='text-input-font md:text-base text-sm w-full h-8
                                                            bg-primary-300 p-2 outline-none' onChange={(e)=>setSearchCategory(e.target.value.toLowerCase())}/>
                                                        </div>
                                                        {categories?.map((category) => {
                                                            return(
                                                                <div key={category.id}>
                                                                    <li
                                                                    className={`cursor-pointer p-2 md:text-base text-sm hover:text-primary-100
                                                                    ${category?.nombre?.toLowerCase() === selected?.toLocaleLowerCase()
                                                                        && 'bg-primary-200 text-white'
                                                                    }
                                                                    ${category?.nombre?.toLowerCase().startsWith(searchCategory) 
                                                                    ? "block" : "hidden"}`}
                                                                    onClick={()=>{
                                                                        if (category?.nombre?.toLowerCase() !== selected.toLocaleLowerCase()) {
                                                                            setSelected(category?.nombre);
                                                                            setOpenDropDownPopUp(false);
                                                                            setSearchCategory("");
                                                                        }
                                                                    }}>{category.nombre}</li>
                                                                </div>
                                                            );
                                                        })}
                                                    </ul>
                                                </div>

                                                <div className='sm:hidden w-52 mt-3'>
                                                    <textarea className={`${openDropDownPopUp? "hidden": "block"} md:text-base py-2 px-3 h-text-area-height w-full text-sm text-input-font bg-primary-300
                                                    focus:outline-none focus:border focus:border-primary-100 focus:shadow-md resize-none`}
                                                    onChange={(ev) => {setTestDescription(ev.target.value)}} value={testDescription}
                                                    id="description" name="description" rows="7" cols="41" placeholder='Descripción'></textarea>
                                                </div>
                                                
                                            </div>

                                            <div className='hidden sm:flex sm:flex-col justify-center items-center w-full sm:space-y-2'>
                                               
                                                <div className='sm:flex sm:flex-col w-52 mt-3 sm:w-5/6'>
                                                    
                                                    <div className='sm:mt-0 cursor-pointer w-full h-input-height py-1 pl-3 text-input-font bg-primary-300 focus:outline-none 
                                                        focus:border focus:border-primary-100 focus:shadow-md
                                                        flex flex-row items-center justify-between'
                                                        onClick={() => setOpenDropDownPopUp(!openDropDownPopUp)}>
                                                            {
                                                                selected ? <p className='md:text-base text-sm overflow-hidden'>{selected}</p> 
                                                                : <p className='md:text-base text-sm overflow-hidden'>Categoría</p>
                                                            }
                                                            
                                                            <ChevronDownIcon className={`text-input-font md:h-5 md:w-5 h-4 w-4 mx-2 hover:cursor-pointer 
                                                            ${openDropDownPopUp && "rotate-180"}`} />
                                                    </div>

                                                    <ul className={`text-input-font bg-primary-300 mt-1 overflow-y-auto 
                                                        ${openDropDownPopUp ? "max-h-24" : "max-h-0"}
                                                    `}>
                                                        <div className='flex items-center px-2 border-b border-primary-100'>
                                                            <MagnifyingGlassIcon className='md:h-5 md:w-5 h-4 w-4 text-placeholder' />
                                                            <input type="text" placeholder="Buscar Categoría"
                                                            value={searchCategory}
                                                            className='text-navFont-100 md:text-base text-sm w-full h-8 
                                                            bg-primary-300 p-2 outline-none' onChange={(e)=>setSearchCategory(e.target.value.toLowerCase())}/>
                                                        </div>
                                                        {categories?.map((category) => {
                                                            return(
                                                                <div key={category.id}>
                                                                    <li  
                                                                    className={`cursor-pointer p-2 md:text-base text-sm hover:text-primary-100
                                                                    ${category?.nombre?.toLowerCase() === selected?.toLocaleLowerCase()
                                                                        && 'bg-primary-200 text-white'
                                                                    }
                                                                    ${category?.nombre?.toLowerCase().startsWith(searchCategory) 
                                                                    ? "block" : "hidden"}`}
                                                                    onClick={()=>{
                                                                        if (category?.nombre?.toLowerCase() !== selected.toLocaleLowerCase()) {
                                                                            setSelected(category?.nombre);
                                                                            setOpenDropDownPopUp(false);
                                                                            setSearchCategory("");
                                                                        }
                                                                    }}>{category.nombre}</li>
                                                                </div>
                                                            );
                                                        })}
                                                    </ul>
                                                </div>

                                                <div className='w-52 mt-3 sm:w-5/6'>
                                                    <textarea className={`${openDropDownPopUp? "hidden": "block"} md:text-base py-2 px-3 h-text-area-height w-full text-sm text-input-font bg-primary-300
                                                    focus:outline-none focus:border focus:border-primary-100 focus:shadow-md resize-none`}
                                                    onChange={(ev) => {setTestDescription(ev.target.value)}} value={testDescription}
                                                    id="description" name="description" rows="7" cols="41" placeholder='Descripción'></textarea>
                                                </div>
                                            </div>
                                        </div>
                                        <div className='w-52 mt-3 flex flex-row'>
                                            <button onClick={updateTest}
                                                className={`w-full h-8 text-sm sm:text-base sm:h-9 bg-primary-100 text-white rounded font-bold hover:bg-primary-200 disabled:bg-primary-200 ${deleteNumbers(test.id)}`}>
                                                {!updating? 
                                                "Guardar"
                                                : 
                                                <div className="w-full flex justify-center items-center"> 
                                                    <svg fill='none' className="w-6 h-6 sm:w-8 sm:h-8 animate-spin" viewBox="0 0 32 32" xmlns='http://www.w3.org/2000/svg'>
                                                    <path clipRule='evenodd'
                                                        d='M15.165 8.53a.5.5 0 01-.404.58A7 7 0 1023 16a.5.5 0 011 0 8 8 0 11-9.416-7.874.5.5 0 01.58.404z'
                                                        fill='currentColor' fillRule='evenodd' />
                                                    </svg> 
                                                    Guardando
                                                </div>}
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                
                                <div className={`hidden relative z-40 popup_delete ${test.id}`} aria-labelledby="modal-title" role="dialog" aria-modal="true" >
                                    <div className="fixed inset-0 bg-popup"></div>

                                    <div className="fixed inset-0 z-10 overflow-y-auto">
                                        <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
                                            <div className="relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg">
                                            <div className="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
                                                <div className="sm:flex sm:items-start">
                                                <div className="mx-auto flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-full bg-red-100 sm:mx-0 sm:h-10 sm:w-10">
                                                    <svg className="h-6 w-6 text-red-600" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" aria-hidden="true">
                                                    <path strokeLinecap="round" strokeLinejoin="round" d="M12 10.5v3.75m-9.303 3.376C1.83 19.126 2.914 21 4.645 21h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 4.88c-.866-1.501-3.032-1.501-3.898 0L2.697 17.626zM12 17.25h.007v.008H12v-.008z" />
                                                    </svg>
                                                </div>
                                                <div className="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
                                                    <h3 className="text-lg font-medium leading-6 text-gray-900" id="modal-title">Eliminar Registro</h3>
                                                    <div className="mt-2">
                                                    <p className="text-sm text-gray-500">¿Está seguro que desea eliminar este registro? Este registro no se podrá recuperar. </p>
                                                    </div>
                                                </div>
                                                </div>
                                            </div>
                                            <div className="bg-gray-50 px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6">
                                                <button onClick={() => {deleteTest(test.id);}} type="button" className="inline-flex w-full justify-center rounded-md border border-transparent bg-danger px-4 py-2 text-base font-medium text-white shadow-sm hover:bg-red-400 focus:outline-none sm:ml-3 sm:w-auto sm:text-sm">Eliminar</button>
                                                <button onClick={() => {closePopupDelete(test.id);}} type="button" className="mt-3 inline-flex w-full justify-center rounded-md border border-gray-300 bg-white px-4 py-2 text-base font-medium text-gray-700 shadow-sm hover:bg-gray-100 focus:outline-none sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm">Cancelar</button>
                                            </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))
                        :
                        <div className='w-full flex h-footer-height justify-center items-center text-4xl text-primary-100 space-x-1'>
                            <svg fill='none' className="w-14 h-14 animate-spin" viewBox="0 0 32 32" xmlns='http://www.w3.org/2000/svg'>
                                <path clipRule='evenodd'
                                    d='M15.165 8.53a.5.5 0 01-.404.58A7 7 0 1023 16a.5.5 0 011 0 8 8 0 11-9.416-7.874.5.5 0 01.58.404z'
                                    fill='currentColor' fillRule='evenodd' />
                            </svg>
                            <div>
                                Cargando...
                            </div>
                        </div>
                        }

                        <div className={`${tests?.length? "flex" : "hidden"} w-full items-center justify-evenly mt-5`}>
                            <span className={`text-sm text-gray-700`}>
                                Mostrando <span className="font-semibold text-gray-900">{lastTestIndex >= tests?.length? tests?.length:lastTestIndex}</span> de <span className="font-semibold text-gray-900">{tests?.length}</span> resultados
                            </span>
                            <div className="inline-flex mt-2 xs:mt-0">
                                <button
                                    onClick={() => {setCurrentPage(currentPage - 1)}} 
                                    className={`${currentPage === 1? "pointer-events-none bg-primary-300" : "text-white bg-primary-100 hover:bg-primary-200"} px-4 py-2 text-sm font-medium rounded-l`}>
                                    Anterior
                                </button>
                                <button 
                                    onClick={() => {setCurrentPage(currentPage + 1)}}
                                    
                                    className={`${lastTestIndex >= tests?.length? "pointer-events-none bg-primary-300" : "text-white bg-primary-100 hover:bg-primary-200"} px-4 py-2 text-sm font-medium border-0 border-l border-white rounded-r`}>
                                    Siguiente
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <FooterAdmin />
        </div>

    )
}

export default TestsAdmin;
